import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import GeneralHome from "../general-home-phone";
import MemberHomeWeb from "components/client-facing-landing-page";
import { useUser } from "contexts/UserContext";

const MemberHome = () => {
  const { user } = useUser();
  const { isPhonePortrait } = usePhonePortraitContext();

  return isPhonePortrait ? (
    !user?.signup_form_finished ? (
      <MemberHomeWeb />
    ) : (
      <GeneralHome />
    )
  ) : (
    <MemberHomeWeb />
  );
};

export default MemberHome;
